import { useCookie } from 'react-use'

import config from '../config'

const useAuthentication = () => {
  // In future this will make calls to customer api to fetch profile.
  // therefore setup as a hook instead of util function
  const [token] = useCookie(config.oAuth2TokenCookieName)
  return !!token
}

export default useAuthentication
